import Vue from 'vue';
import axios from 'axios';

import Load from '@/utils/loading';

// const service = axios.create({}); options.isFile
/**
 *
 * @param {string} method
 * @param {any[] | {[key: PropertyKey]: any}} data
 * @param {{ load: boolean, resType: | 'arraybuffer' | 'blob' | 'document' | 'json' | 'text' | 'stream' }} options
 * @returns
 */
const ajax = (method, data = [], options = { load: false, resType: 'json' }) => {
  const JXPTAPI = Vue.prototype.JXPT_API;
  const PAYAPI = Vue.prototype.PAY_API;
  return new Promise((resolve, reject) => {
    let c = null;
    let m = null;
    if (method && method.indexOf('.') != -1) {
      let _arr = method.split('.');
      c = _arr[0];
      m = _arr[1];
    } else {
      alert('错误：没有指定可用的方法');
      return;
    }

    let url = JXPTAPI;

    switch (c) {
      case 'Product':
      case 'clientPaymentCenter':
      case 'ManagerUsers':
      case 'PrepaidOrders':
      case 'coupon':
      case 'statisManage':
        url = PAYAPI;
        break;
      default:
        url = JXPTAPI;
        break;
    }

    let spliceUrl = `${url}/Demo/f/all/${c}.action`;

    let params = [];

    if (typeof data == 'object' && !(data instanceof Array)) {
      for (var key in data) {
        params.push(data[key]);
      }
    } else {
      params = data;
    }

    let apiData = JSON.stringify({ method: m, params: params });
    // let apiData = encodeURIComponent(JSON.stringify({ method: m, params: params }));
    // ajax源码对参数进行了二次encodeURI加密，但是axios又没有加密，所以需要进行一次手动的二次加密 ( 登陆接口密码里有%的用户无法登陆 )
    // apiData = encodeURIComponent(encodeURIComponent(apiData));

    if (options.load) Load.instance.show();

    //var promise = service.post(spliceUrl, `corsClient=${apiData}`, {
    //   headers: {
    //     // application/x-www-form-urlencoded
    //     'Content-Type': 'application/x-www-form-urlencoded',
    //     Accept: 'text/plain, */*; q=0.01'
    //   }
    // });
    // promise

    axios
      .post(spliceUrl, `corsClient=${apiData}`, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Accept: 'text/plain, */*; q=0.01',
        },
        responseType: options.resType,
      })
      .then((res) => {
        if (options.load) Load.instance.close();
        if (options.resType === 'blob') {
          let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }); // res就是接口返回的文件流了
          let objectUrl = URL.createObjectURL(blob);
					const elink = document.createElement("a");

          const contentDisposition = res.headers['content-disposition'];

          let fileName;
          if (contentDisposition) {
            const regex = /filename\*=([^;]+?)\''?'([^;]*)/; // 关键点：两个单引号直接相连
            const match = contentDisposition.match(regex);
            if (match) {
              // 提取字符集（如 utf-8）和 URL 编码部分
              const [, charsetPart, encodedPart] = match;
              const charset = charsetPart.split("''")[0]; // 处理可能的多余分隔符（虽然规范中不应有）
              const urlEncodedFilename = encodedPart.trim(); // 去除可能的空格
              // 解码
              fileName = decodeURIComponent(urlEncodedFilename);
            }else {
              fileName = '续费记录';
            }
          } else {
            fileName = '续费记录';
          }
          elink.download = fileName; //下载文件名称,
					elink.style.display = "none";
					elink.href = objectUrl;
					document.body.appendChild(elink);
					elink.click();
					URL.revokeObjectURL(elink.href); // 释放URL 对象
					document.body.removeChild(elink);
          resolve(true);
        } else if (res.status === 200 && res.data.state == true) {
          if (res.data.result != null || res.data.result != undefined) {
            resolve(res.data.result);
          } else if (res.data.state == true) {
            // console.log(res.data);
            resolve(null);
          } else {
            reject(res.data.result);
          }
        } else {
          reject(res.data);
        }
      })
      .catch((err) => {
        if (options.load) Load.instance.close();

        if (!window[sessionStorage.getItem('printErrorM')] && m != 'printErrorLog') {
          let _m = JSON.parse(JSON.stringify(m));
          let _apiData = JSON.parse(JSON.stringify(apiData));

          sessionStorage.setItem('printErrorM', _m); //接口名字
          sessionStorage.setItem('printErrorLog', _apiData); //接口名字加参数

          window[sessionStorage.getItem('printErrorM')] = true;
          ajax('clientPaymentCenter.printErrorLog', {
            errorMsg: decodeURIComponent(
              decodeURIComponent(sessionStorage.getItem('printErrorLog'))
            ),
          });
        }

        if (Vue) {
          Vue.prototype.$toast({
            icon: 2,
            msg: '服务未成功启动',
            duration: 5e3,
          });
        } else {
          alert('服务未成功启动');
        }
        throw { err };
      });
  });
};

export default ajax;



// WEBPACK FOOTER //
// ./src/utils/api.js